import {
  GoogleMap,
  Marker,
  Autocomplete,
  useLoadScript,
} from "@react-google-maps/api";
import { useRef, useState } from "react";
import TextInput from "./TextInput";

const libraries = ["places"];

export const LocationPicker = ({ value, onChange }) => {
  const autocompleteRef = useRef(null);

  const { isLoaded } = useLoadScript({
    googleMapsApiKey: "AIzaSyCOh0Fhlg8WjA9-iVL1pl7hCweo17fH7xg",
    libraries,
  });

  const center = {
    lat: value.Latitude || 14.6519,
    lng: value.Longitude || 121.0583,
  };

  const extractAddress = (place) => {
    const components = place.address_components || [];

    const get = (type) =>
      components.find((c) => c.types.includes(type))?.long_name || "";

    const a = {
      Address: place.formatted_address,
      City: get("locality") || get("administrative_area_level_2"),
      Province: get("administrative_area_level_1"),
      PostalCode: get("postal_code"),
      Country: get("country"),
    };

    console.log('a: ', a);
    console.log('components: ', components);
    return a;
  };

  const handlePlaceChanged = () => {
    const place = autocompleteRef.current.getPlace();
    if (!place.geometry) return;

    const location = place.geometry.location;
    const addressData = extractAddress(place);

    onChange({
      ...value,
      ...addressData,
      Latitude: location.lat(),
      Longitude: location.lng(),
    });
  };

  const handleMarkerDragEnd = (e) => {
    onChange({
      ...value,
      Latitude: e.latLng.lat(),
      Longitude: e.latLng.lng(),
    });
  };

  if (!isLoaded) return <p>Loading map...</p>;

  return (
    <div style={{ width: "100%" }}>
      <Autocomplete
        onLoad={(ref) => (autocompleteRef.current = ref)}
        onPlaceChanged={handlePlaceChanged}
      >
        <TextInput
          placeholder="Search location"
          value={value.Address}
          onChange={(_val) => onChange({ ...value, Address: _val })}
          label={"Address"}
        />
      </Autocomplete>

      <GoogleMap
        center={center}
        zoom={16}
        mapContainerStyle={{ width: "100%", height: "350px" }}
      >
        <Marker position={center} draggable onDragEnd={handleMarkerDragEnd} />
      </GoogleMap>
    </div>
  );
};
